import { namespace } from '../../runtime'
import type en from './en'

/**
 * The sport packs' words in French and Spanish (#1118), read through
 * localizePack() / sportWords() (src/contexts/sportPackI18n.ts), never directly.
 *
 * English is the packs' own words (served by the API), so the English
 * catalogue is never read at run time and is left out of the bundle: the
 * namespace's English is empty. en.ts stays the translators' source and is
 * checked against the backend packs.
 */
export const sportPackMessages = namespace('sport-packs', {} as typeof en, {
  fr: () => import('./fr'),
  es: () => import('./es'),
})
